import * as React from 'react'
import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: fit-content;
  display: inline-flex;
`

type PropsType = {
  children: React.ReactElement<any>
  id: string
  tip: string
  wrap: boolean
}

class TooltipHost extends React.PureComponent<PropsType> {
  componentDidMount() {
    ReactTooltip.rebuild()
  }

  render() {
    const { children, id, tip, wrap, ...rest } = this.props
    const dataTip = tip || []

    if (!wrap)
      return React.cloneElement(children, {
        'data-for': id,
        'data-tip': dataTip,
        ...rest
      })

    return (
      <Wrapper data-for={id} data-tip={dataTip} {...rest}>
        {children}
      </Wrapper>
    )
  }
}

export default TooltipHost
